import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsPanel = ({ statistics }) => {
  const { totalGems, rarityDistribution, nextMilestone, collectionValue } = statistics;

  const rarityData = [
    { 
      rarity: 'Common', 
      count: rarityDistribution?.common, 
      color: 'accent',
      icon: 'Gem'
    },
    { 
      rarity: 'Rare', 
      count: rarityDistribution?.rare, 
      color: 'primary',
      icon: 'Diamond'
    },
    { 
      rarity: 'Epic', 
      count: rarityDistribution?.epic, 
      color: 'secondary',
      icon: 'Crown'
    },
    { 
      rarity: 'Legendary', 
      count: rarityDistribution?.legendary, 
      color: 'warning',
      icon: 'Sparkles'
    }
  ];

  const maxCount = Math.max(...rarityData?.map(r => r?.count));

  return (
    <div className="statistics-panel bg-card border-2 border-secondary rounded-sm p-4 md:p-6 lg:p-8 shadow-glow-magenta-md">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-sm bg-secondary/20 border border-secondary flex items-center justify-center shadow-glow-magenta-sm">
          <Icon name="BarChart3" size={24} color="var(--color-secondary)" />
        </div>
        <div>
          <h2 className="font-heading font-bold text-lg md:text-xl lg:text-2xl text-secondary">
            Collection Stats
          </h2>
          <p className="text-xs md:text-sm text-muted-foreground font-caption">
            Your Achievement Overview
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="bg-background rounded-sm border border-accent/30 p-3 md:p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Gem" size={18} color="var(--color-accent)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              Total Gems
            </span>
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-accent">
            {totalGems?.toLocaleString('en-US')}
          </p>
        </div>

        <div className="bg-background rounded-sm border border-warning/30 p-3 md:p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="DollarSign" size={18} color="var(--color-warning)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              Value
            </span>
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-warning">
            ${collectionValue?.toLocaleString('en-US')}
          </p>
        </div>
      </div>
      <div className="bg-background rounded-sm border border-primary/30 p-4 md:p-5 mb-4 md:mb-6">
        <h3 className="font-heading font-semibold text-sm md:text-base text-primary mb-4 flex items-center gap-2">
          <Icon name="PieChart" size={18} />
          Rarity Distribution
        </h3>
        <div className="space-y-3 md:space-y-4">
          {rarityData?.map((item) => (
            <div key={item?.rarity}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <Icon name={item?.icon} size={16} color={`var(--color-${item?.color})`} />
                  <span className="text-xs md:text-sm font-caption text-foreground">
                    {item?.rarity}
                  </span>
                </div>
                <span className={`text-sm md:text-base font-data font-bold text-${item?.color}`}>
                  {item?.count}
                </span>
              </div>
              <div className="w-full bg-muted rounded-sm h-2 overflow-hidden">
                <div 
                  className={`h-full bg-${item?.color} transition-all duration-base`}
                  style={{ width: `${maxCount > 0 ? (item?.count / maxCount) * 100 : 0}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-background rounded-sm border border-secondary/30 p-4 md:p-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading font-semibold text-sm md:text-base text-secondary flex items-center gap-2">
            <Icon name="Target" size={18} />
            Next Milestone
          </h3>
          <span className="text-xs md:text-sm font-data text-muted-foreground">
            {nextMilestone?.current}/{nextMilestone?.target}
          </span>
        </div>
        <div className="w-full bg-muted rounded-sm h-3 md:h-4 overflow-hidden mb-2">
          <div 
            className="h-full bg-secondary transition-all duration-base"
            style={{ width: `${(nextMilestone?.current / nextMilestone?.target) * 100}%` }}
          />
        </div>
        <p className="text-xs md:text-sm text-muted-foreground font-caption">
          {nextMilestone?.target - nextMilestone?.current} gems until {nextMilestone?.reward}
        </p>
      </div>
    </div>
  );
};

export default StatisticsPanel;